import { useCallback, useRef, useState } from "react";
import type { VliteInstance, VlitePlayerType } from "../types";

export function useVlitePlayer() {
  const ref = useRef<VliteInstance | null>(null);
  const [player, setPlayer] = useState<VlitePlayerType | null>(null);

  const onReady = useCallback((instance: VlitePlayerType) => {
    setPlayer(instance);
  }, []);

  return {
    ref,
    onReady,
    player,
  } as const;
}
